<template>
  <main id="main" class="hero" role="main" style="pointer-events: none">
    <div class="wrap">
      <div class="grid">
        <div>
          <h1>{{ title }}</h1>
          <p class="lede">
            <b>&capital</b> {{ description }}
          </p>
          <div class="cta">
            <BaseButton
              tag="a"
              variant="primary"
              :href="primaryCTA.href"
            >
              {{ primaryCTA.label }}
            </BaseButton>
            <BaseButton
              tag="a"
              variant="secondary"
              :href="secondaryCTA.href"
            >
              {{ secondaryCTA.label }}
            </BaseButton>
          </div>
        </div>
        <aside class="hero-card">
          <span class="tag">{{ cardTag }}</span>
          <ul class="bullets">
            <li v-for="(item, index) in bulletPoints" :key="index">
              {{ item }}
            </li>
          </ul>
          <div class="sep"></div>
          <div class="stripe">
            <span
              v-for="(chip, index) in chips"
              :key="index"
              class="chip"
            >
              {{ chip }}
            </span>
          </div>
        </aside>
      </div>
    </div>
    
<div class="watermark" aria-hidden="true">&</div>
  </main>
</template>

<script setup>
import { ref } from 'vue';
import BaseButton from './BaseButton.vue';


// Props with defaults
const props = defineProps({
  title: {
    type: String,
    default: 'Independent placement\nfor independent managers.'
  },
  description: {
    type: String,
    default: 'partners with specialist alternative investment managers to raise institutional capital—thoughtfully, selectively, and with genuine alignment.'
  },
  primaryCTA: {
    type: Object,
    default: () => ({
      label: 'Start a conversation',
      href: '#contact'
    })
  },
  secondaryCTA: {
    type: Object,
    default: () => ({
      label: 'Our approach',
      href: '#what'
    })
  },
  cardTag: {
    type: String,
    default: 'At a glance'
  },
  bulletPoints: {
    type: Array,
    default: () => [
      'Private-markets placement & strategic advisory',
      'Institutional LP coverage across pensions, insurers, endowments, foundations, and family offices',
      'Focus on differentiated strategies, quality of process, and long-term relationships'
    ]
  },
  chips: {
    type: Array,
    default: () => [
      'Private Credit',
      'Insurance/ILS',
      'Specialty Finance',
      'Litigation Finance',
      'Real Assets',
      'Select PE Strategies'
    ]
  }
});
</script>

<style scoped>
/* Hero styles are inherited from global styles.css */
/* Component-specific overrides can go here if needed */

h1 {
  white-space: pre-line;
}
</style>
